import { BasicsClass } from '@/common/BasicsClass';
import { Util } from '@/common/util';

export class DeviceGateAPI extends BasicsClass {
    public apiUrls: any = new Map([
        // ['forbideenUserAccount', {
        //     url: '/user/forbid',
        //     name: 'account-forbid',
        //     label: '账户封禁'
        // }],
        ['getDeviceGateTableList', {
            url: '/admin/device/list',
            name: 'list',
            label: '列表'
        }],
        ['removeDeviceGate', {
            url: '/admin/device/unbind',
            name: 'device-gate-unbind',
            label: '设备(总开关)解绑',
            // hidden: true
        }],

        ['checkDeviceGateHard', {
            url: '/admin/device/upgradeCheck',
            name: 'check-device-gate-hard',
            label: '检测设备固件',
        }],
        ['deviceGateHardUpgrade', {
            url: '/admin/device/upgrade',
            name: 'upgrade-device-gate-hard',
            label: '升级设备固件',
        }]
    ])


    // // 设备（总开关）列表
    public getDeviceGateTableList(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
      const apiUrls = this.apiUrls

      const url = apiUrls.get('getDeviceGateTableList').url

      this.BasicPost(url, {
          ...params
      }, false, false, false, successCb, failCb, showLoading)
    }

    // // 设备（总开关）解绑
    public removeDeviceGate(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
        const apiUrls = this.apiUrls

        const url = apiUrls.get('removeDeviceGate').url

        this.BasicPost(url, {
            ...params
        }, false, false, false, successCb, failCb, showLoading)
    }

    // // 检测设备固件
    public checkDeviceGateHard(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
        const apiUrls = this.apiUrls

        const url = apiUrls.get('checkDeviceGateHard').url

        this.BasicPost(url, {
            ...params
        }, false, false, false, successCb, failCb, showLoading)
    }

    // // 升级设备固件
    public deviceGateHardUpgrade(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
        const apiUrls = this.apiUrls

        const url = apiUrls.get('deviceGateHardUpgrade').url

        this.BasicPost(url, {
            ...params
        }, false, false, false, successCb, failCb, showLoading)
    }

}